export default "__VITE_ASSET__CE0JJGxU__"